// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bfa2a6e9","453":"9e7511c7","455":"a903a41d","977":"23416b25"}[chunkId] + ".chunk.js";
};